var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "tit": "문의하기",
      "sc": "마이스펙에 문의하세요(임시txt)",
      "bg": "/images/sub/visual/sv-question.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('inquiry-input')], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }